import { createGrowthBookInstance, initializeGrowthBook } from '../utils/growthbook';

const USER_API_ROUTES_FEATURE = 'cms_learn_user_api_routes';


export const getLearnApiRequestConfig = async (route) => {
  let useUserRoutes = false;
  try {
    const growthbook = createGrowthBookInstance();
    if (await initializeGrowthBook(growthbook)) {
      useUserRoutes = growthbook.getFeatureValue(USER_API_ROUTES_FEATURE, false) === true;
    }
  } catch (error) {
    useUserRoutes = false;
  }

  const headers = { 'Content-Type': 'application/json' };
  const userApiBaseUrl = (process.env.LEARN_API_BASE_URL || '').trim().replace(/\/+$/, '');
  if (useUserRoutes && userApiBaseUrl) {
    return {
      url: `${userApiBaseUrl}${route}`,
      headers,
      withCredentials: true
    };
  }

  return {
    url: `${process.env.CHEKLIST_API}${route}`,
    headers: {
      ...headers,
      Authorization: 'Basic ' + btoa(`${process.env.CLIENT_ID}:${process.env.CLIENT_SECRET}`)
    }
  };
};
